import { makeStyles } from "@mui/styles";

export const useStyle = makeStyles((theme) => ({
 
 
  tblRoot: {
    "&.MuiTableContainer-root": {
        
      height: "100%",
      "&::-webkit-scrollbar": {
        width: "10px",
      },
      "&:hover::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.palette.grey[100],
      },
      "&::-webkit-scrollbar-thumb": {
        border: "2px solid #A9A9A9",
        borderRadius: "20px",
        backgroundColor: theme.palette.common.white,
        backgroundClip: "content-box",
      },
    },
  },
  table: {
    position: "relative",
    // outline: `0.5px solid #ccc`,
    borderRadius: "4px",
  },
  tablrow: {
    "&.MuiTableRow-root": {
      "& .MuiTableCell-root": {
        textAlign: "center",
        padding: "5px",
        borderRight: `1px solid #ccc`,
      },
    },
  },
  tblHeader: {
    "&.MuiTableHead-root": {
      "& .MuiTableCell-root": {
        fontWeight: 600,
        backgroundColor: "#A06EE1",
        paddingBlock: "6px",
        color: "#fff",
        letterSpacing: 1,
      },
    },
  },
  fieldBox: {
    "&.MuiTextField-root": {
      height: "20px",
      backgroundColor: "red",
    },
  },
  tblContentCell: {
    "&.MuiTableCell-root": {
      textAlign: "center",
      padding: "0px",
      borderBottom:'0.5px solid  #ccc',
      "& .MuiTextField-root": {
        "& .MuiOutlinedInput-root": {
          height: 30,
          padding: 0,
          // backgroundColor: theme.palette.grey[50],
          "& fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&:hover fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#fff",
            borderWidth: "1.4px",
          },
        },
      },
      // border: `1px solid #ccc`,
    },
    
  },
}));

